import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import {
    ComponentsModule,
    ModalModule,
    ModalService,
} from '@jht/brand-components';
import { DirectivesModule } from '@jht/brand-directives';
import { TranslateModule } from '@jht/brand-translate';
import { PipesModule } from '@jht/brand-pipes';

import { LanguageSelectorModule } from '../language-selector/language-selector.module';
import { NavigationComponent } from './navigation.component';
import { NavigationMobileComponent } from './navigation-mobile/navigation-mobile.component';

const SERVICES = [
    // { provide: Window, useValue: window },
    // { provide: window, useValue: {} },
    ModalService,
];

@NgModule({
    declarations: [NavigationComponent, NavigationMobileComponent],
    imports: [
        CommonModule,
        ComponentsModule,
        RouterModule,
        TranslateModule,
        DirectivesModule,
        LanguageSelectorModule,
        ModalModule,
        PipesModule,
    ],
    providers: [SERVICES],
    exports: [NavigationComponent, NavigationMobileComponent],
})
export class NavigationModule {}
